import type React from 'react';
import styled from '@emotion/styled';

import { ReactComponent as TrashIcon } from 'assets/images/trash-icon.svg';

interface TrashProps {
  onClick?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const Trash = styled(TrashIcon)<TrashProps>`
  cursor: pointer;
  transition: opacity 200ms ease-out;
  width: 16px;
  height: 19px;

  &:hover {
    opacity: 0.7;
  }
  path,
  g {
    fill: var(--icon-primary-standalone);
  }
`;

export default Trash;
